module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch3",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('h1', {
    staticClass: "CN",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "26",
      "id": "pg_26",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLASHBACK: KIMBERLY, AGE 10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Her eyes nearly blinded with tears, ten-year-old Kimberly fled out of the schoolyard, stumbled across Porter Road, and ran all the way home.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My dress, she kept thinking. My new dress. They ruined it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Her mother was in the front yard, working on her bed of chrysanthemums. Once she saw Kimberly she dropped her trowel and ran to her only child, her normally placid Japanese features wide-eyed with sudden alarm.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What happened?” her mother shouted. “Your dress is filthy!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Kimberly rushed to her arms, still crying. She tried to explain between gasping sobs. “They said I was too dark to wear a white dress! They threw mud at me! Five of them!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Mama brushed the tears away, wrapped a protective arm around her daughter, and led her into the house. Kimberly’s father was at the door, his lean, ascetic face worried, alarmed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It took several minutes for them to get Kimberly soothed down. Mama led her upstairs, helped her take off the ruined dress, and cleaned her up.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "27",
      "id": "pg_27",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“There were five of them,” Kimberly told her, calmer now. “Marla Kingston was the leader. I hate her!”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was the first day of the new term. Kimberly had been advanced one whole grade, she was so bright. But some of the older girls did not like their new dark-skinned arrival.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Five of them,” Kimberly repeated. “They threw mud at me. They said I was too dark to be with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By the time Mama led her downstairs again Kimberly was almost calm. But she could feel the anger burning inside her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Her father was waiting at the foot of the stairs. “Come with me, Kimberly,” he said, leading her into his office.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dr. Harold Hadid was a third-generation Saudi Englishman who had emigrated to the United States to pursue a career in neurosurgery. Tall and reserved, he’d had to face the inborn, unconscious intolerance of the British class system and decided to move to America. There he had met his California-born, Japanese American wife, excelled in school at Johns Hopkins, and settled in the Washington, D.C., area.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He sat Kimberly in the big leather armchair that was usually reserved for guests and listened patiently to her story about the other girls’ bullying.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I hate her!” Kimberly concluded. “Marla Kingston. I hate her!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Sitting on the rocker next to her, Papa raised a slim finger.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hate is a vicious emotion,” he said softly. “It can lead you to do things you’ll regret later on.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But she—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("With one of his rare smiles, Papa said, “Let me give a word of advice, Kimberly. An American politician, a U.S. senator, in fact, once said, ‘Don’t get mad, get even.’ Think about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Kimberly did think about it. When she returned to school later "), _c('span', {
    attrs: {
      "aria-label": "28",
      "id": "pg_28",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("that day, she went straight to the principal’s office to explain that she had gone home to change her dress, which had somehow gotten begrimed with mud.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She kept to herself, avoiding most of the other girls in her class, and everyone forgot about Kimberly’s muddied dress.…")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A few months later, she won the top score in the class’s state exams. And somehow Marla Kingston’s paper disappeared and she had to retake the test after regular class hours. Even then, her paper was rejected by the computer scoring device because of illegible handwritten sections.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And years later, when Kimberly and Marla Kingston were seniors at Johns Hopkins University, Marla’s cell phones, laptops, and other digital devices malfunctioned so often that Ms. Kingston was reduced to tears.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('i', [_vm._v("Don’t get mad, get even")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5755fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 81
// module chunks = 0